import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GochiMenuEventTableHead from '../../components/molecules/GochiMenuEventTableHead';
import GochiMenuEventTableBody from '../../components/molecules/GochiMenuEventTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import GochiMenuEventDetail from './GochiMenuEventDetail';
import GochiMenuEventEdit from './GochiMenuEventEdit';
// import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';
// import {
//   getGochiMenus,
//   getGochiMenuDetail,
//   deleteGochiMenu,
//   showHideGochiMenu
// } from '../../actions/GochiMenus';
import {
  getGochiMenusEvent,
  changeStatusMenuEvent,
  getGochiMenuEventDetail,
  showHideGochiMenuEvent
} from '../../actions/GochiMenusEvent';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      menus: state.gochiMenusEvent.list,
      totalCount: state.gochiMenusEvent.count,
      offset: state.gochiMenusEvent.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenusEvent,
          changeStatusMenuEvent,
          getGochiMenuEventDetail,
          showHideGochiMenuEvent
          // getGochiMenus,
          // getGochiMenuDetail,
          // deleteGochiMenu,
          // showHideGochiMenu
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuChildType', 'setMenuChildType', 0),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('menuEventId', 'setMenuEventId', 0),
  withState('menuEventName', 'setMenuEventName', ''),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  // withState('displayAmount', 'setDisplayAmount', 0),
  withState('premiumPercent', 'setPremiumPercent', 0),
  withState('menuLimitTotal', 'setMenuLimitTotal', 0),
  withState('description', 'setDescription', ''),
  withState('prefectures', 'setPrefectures', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('taxTypeStr', 'setTaxTypeStr', '外税'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('reducedTaxTypeStr', 'setReducedTaxTypeStr', '対象外'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('page', 'setPage', 0),
  withState('openShowHide', 'updateOpenShowHide', false),
  withState('openChangeStatus', 'updateOpenChangeStatus', false),
  withState('showHide', 'setShowHide', 1),
  withState('status', 'setStatus', 1),
  withState('manual', 'setManual', 0),
  withState('otherLanguages', 'setOtherLanguages', {}),
  withState('gochimeshiFlag', 'setGochimeshiFlag', 1),
  withState('isETicket', 'setIsETicket', 1),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    page,
    selectedPage,
    handleChangePage,
    menus,
    totalCount,
    offset,
    name,
    openDetailModal,
    updateOpenDetailModal,
    // openDelete,
    updateOpenDelete,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    // updateIsDeleteSuccess,
    resultMessage,
    // setResultMessage,
    // menuChildType,
    // setMenuChildType,
    // groupId,
    // setGroupId,
    groupName,
    setGroupName,
    // shopId,
    // setShopId,
    // shopName,
    // setShopName,
    menuEventId,
    setMenuEventId,
    menuEventName,
    setMenuEventName,
    menuName,
    setMenuName,
    price,
    setPrice,
    // displayAmount,
    // setDisplayAmount,
    premiumPercent,
    setPremiumPercent,
    menuLimitTotal,
    setMenuLimitTotal,
    description,
    setDescription,
    prefectures,
    taxType,
    setTaxType,
    taxTypeStr,
    setTaxTypeStr,
    reducedTaxType,
    setReducedTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxTypeStr,
    setReducedTaxTypeStr,
    setPrefectures,
    tags,
    setTags,
    tagStr,
    setTagStr,
    image,
    setImage,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort,
    openChangeStatus,
    updateOpenChangeStatus,
    openShowHide,
    updateOpenShowHide,
    status,
    setStatus,
    showHide,
    setShowHide,
    manual,
    setManual,
    otherLanguages,
    setOtherLanguages,
    handleRedirect,
    gochimeshiFlag,
    setGochimeshiFlag,
    isETicket,
    setIsETicket
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const paramShowHide = {
      showHide
    };
    const paramChangeStatus = {
      status
    };
    const detail = {
      // menuChildType,
      // shopId,
      // shopName,
      // groupId,
      groupName,
      menuEventId,
      menuEventName,
      menuName,
      price,
      prefectures,
      taxType,
      taxTypeStr,
      reducedTaxType,
      reducedTaxCheck,
      reducedTaxTypeStr,
      // displayAmount,
      premiumPercent,
      menuLimitTotal,
      description,
      manual,
      gochimeshiFlag,
      tags,
      tagStr,
      image,
      createdAt,
      updatedAt,
      otherLanguages,
      isETicket
    };
    const getGochiMenuEvent = async id => {
      await actions.getGochiMenuEventDetail(id).then(detailData => {
        checkSession(detailData);
        // setMenuChildType(detailData.payload.menuChildType);
        // setGroupId(detailData.payload.groupId);
        // setShopId(detailData.payload.shopId);
        // setShopName(detailData.payload.shopName);
        setDescription(detailData.payload.description);
        setReducedTaxType(detailData.payload.reducedTaxType);
        setMenuEventName(detailData.payload.menuEventName);
        setMenuEventId(detailData.payload.menuEventId);
        setMenuName(detailData.payload.menuName);
        setPrice(detailData.payload.price);
        // setDisplayAmount(detailData.payload.displayAmount);
        setPremiumPercent(detailData.payload.premiumPercent);
        setMenuLimitTotal(detailData.payload.menuLimitTotal);
        setTaxType(detailData.payload.taxType);
        setTaxTypeStr(detailData.payload.taxTypeStr);
        setPrefectures(detailData.payload.prefectures);
        setIsETicket(detailData.payload.isETicket);
        if (detailData.payload.group.groupName) {
          setGroupName(detailData.payload.group.groupName);
        } else {
          setGroupName('');
        }
        setManual(detailData.payload.manual);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          setReducedTaxCheck(true);
          setReducedTaxTypeStr('対象');
        } else {
          setReducedTaxCheck(false);
          setReducedTaxTypeStr('対象外');
        }
        setTags(detailData.payload.tags);
        if (detailData.payload.tags) {
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
        } else {
          setTagStr(null);
        }
        setImage(detailData.payload.image);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setOtherLanguages(detailData.payload.otherLanguages);
        setGochimeshiFlag(detailData.payload.gochimeshiFlag);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiMenuEvent(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGochiMenuEvent(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEdit(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const changeStatusOpenAction = params => {
      updateOpenChangeStatus(true);
      if (params.status) {
        setStatus(0);
      } else {
        setStatus(1);
      }
      setTargetRowId(params.id);
    };
    const cancelChangeStatusAction = () => updateOpenChangeStatus(false);
    const changeStatusAction = async () => {
      updateLoading(true);
      const changeStatusMenu = await actions
        .changeStatusMenuEvent(targetRowId, paramChangeStatus)
        .then(data => checkSession(data));
      if (changeStatusMenu.type === 'CHANGE_STATUS_MENU_EVENT_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenChangeStatus(false);
      } else {
        updateLoading(false);
        updateOpenChangeStatus(false);
      }
    };

    // const deleteOpenAction = id => {
    //   updateOpenDelete(true);
    //   setTargetRowId(id);
    // };
    // const cancelAction = () => updateOpenDelete(false);
    // const deleteAction = async () => {
    //   updateLoading(true);
    //   updateOpenDeleteProgress(true);
    //   const deletedMenu = await actions
    //     .deleteGochiMenu(targetRowId)
    //     .then(data => checkSession(data));
    //   if (deletedMenu.type === 'DELETE_GOCHI_MENU_SUCCESS') {
    //     updateIsDeleteSuccess(true);
    //     handleChangePage(null, selectedPage, rowsPerPage);
    //     setResultMessage('削除が完了しました。');
    //     updateLoading(false);
    //   } else {
    //     updateIsDeleteSuccess(false);
    //     setResultMessage('削除に失敗しました。');
    //     updateLoading(false);
    //   }
    // };

    const showHideOpenAction = params => {
      updateOpenShowHide(true);
      if (params.showHide) {
        setShowHide(0);
      } else {
        setShowHide(1);
      }
      setTargetRowId(params.id);
    };
    const cancelShowHideAction = () => updateOpenShowHide(false);
    const showHideAction = async () => {
      updateLoading(true);
      const showHidedMenuEvent = await actions
        .showHideGochiMenuEvent(targetRowId, paramShowHide)
        .then(data => checkSession(data));
      if (showHidedMenuEvent.type === 'SHOW_HIDE_GOCHI_MENU_EVENT_SUCCESS') {
        handleChangePage(null, selectedPage, rowsPerPage);
        updateLoading(false);
        updateOpenShowHide(false);
      } else {
        updateLoading(false);
        updateOpenShowHide(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GochiMenuEventTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              // roles={roles}
            />
            <GochiMenuEventTableBody
              menus={menus}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              detailOpenAction={detailOpenAction}
              editOpenAction={editOpenAction}
              showHideOpenAction={showHideOpenAction}
              // deleteOpenAction={deleteOpenAction}
              changeStatusOpenAction={changeStatusOpenAction}
              setTargetRowId={setTargetRowId}
              roles={roles}
              order={order}
              orderBy={orderBy}
              handleRedirect={handleRedirect}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={menus}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <GochiMenuEventDetail
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
          />
        </Modal>
        <Modal open={openEdit}>
          <GochiMenuEventEdit
            name={name}
            // roles={roles}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
          />
        </Modal>
        <ConfirmDialog
          openConfirm={openShowHide}
          cancelAction={cancelShowHideAction}
          updateOpenConfirm={updateOpenShowHide}
          okAction={showHideAction}
          targetRowId={targetRowId}
          message="表示状況を変更します。よろしいでしょうか？"
        />
        <ConfirmDialog
          openConfirm={openChangeStatus}
          cancelAction={cancelChangeStatusAction}
          updateOpenConfirm={updateOpenChangeStatus}
          okAction={changeStatusAction}
          targetRowId={targetRowId}
          message="メニューの生成作業を変更しますか？"
        />
        {/* <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="メニュー"
        /> */}
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
